module.exports = __webpack_public_path__ + "static/media/14.140b7afb.jpg";